import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { AppContext } from "../../context/AppContext";
import {
  Download,
  Store,
  ChevronDown,
  ChevronRight,
  BarChart3,
  Receipt,
  IndianRupee,
  AlertCircle,
  RefreshCw,
} from "lucide-react";
import { PostCallWithErrorResponse, simpleGetCall } from "../../api/ApiServices";
import { filter } from "lodash";
import { notifyError } from "../../toaster/notify";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { Calendar } from "lucide-react"; // npm install lucide-react
import { ToastMsg } from "../TostMsg";
import StoreSelector from "../StoreSelector";

const OrderSummaryReport = () => {
  const {
    sidebar,
    setSidebar,
    Dark,
    setDark,
    selectedStoreID,
    selectedRestID,
    ApiConfig,
    storesList,
    permissions,
    setSelectedStoreID
  } = useContext(AppContext);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  console.log('storesList--', storesList, selectedRestaurants)
  const [reportData, setReportData] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  // Convert storesList to react-select options
  const restaurantOptions = useMemo(() => {
    return (storesList || []).map((store) => ({
      value: store.value,
      label: store.label,
    }));
  }, [storesList]);

  const handleExport = () => {
    setLoadingReport(true);

    const requestBody = JSON.stringify({
      start_date: fromDate,
      end_date: toDate,
      shop_ids: selectedRestaurants.map((r) => r.value) || [],
    });

    PostCallWithErrorResponse(
      ApiConfig.POST_ORDER_SUMMARY_REPORT,
      requestBody
    )
      .then((res) => {
        if (res.json && res.json?.success === true) {
          setReportData(res.json.data || []);
          // ToastMsg("success", res.json.message || "Report loaded");
        } else {
          ToastMsg("error", res.json?.message || "Failed to load report");
        }
      })
      .catch((err) => {
        console.error(err);
        ToastMsg("error", "Something went wrong");
      })
      .finally(() => {
        setLoadingReport(false);
      });
  };



  function downloadExcelFromResponse(response, fileName = "report.xlsx") {
    setLoadingExport(true);
    response.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    });

    setLoadingExport(false);
  }

  const getSalesReportExport = async () => {
    setLoadingExport(true);
    if (!fromDate ||
      !toDate ||
      selectedRestaurants.length === 0) {
      notifyError("Please select all filters");
      setLoadingExport(false);
      return;
    }

    const requestBody = JSON.stringify({
      start_date: fromDate,
      end_date: toDate,
      shop_ids: selectedRestaurants.map((r) => r.value) || [],
    });

    try {
      const response = await fetch(
        ` ${ApiConfig?.POST_ORDER_SUMMARY_REPORT_EXPORT}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("Token"),
          },
          body: requestBody
        }
      );

      if (!response.ok) {
        throw new Error("Download failed");
      }

      downloadExcelFromResponse(response, "reports.xlsx");
    } catch (err) {
      notifyError("Something went wrong");
      console.error("Status API Error:", err);
    } finally {
      setLoadingExport(false)
    }
  };


  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="role-content-main">
        <div className="bg-light min-vh-100 p-2 p-md-3">
          <div
            className="container-fluid px-0 px-md-3" /* style={{ maxWidth: '1480px' }} */
          >
            {/* Header Section */}

            <div className="card shadow-sm border-0 mb-3">
              <div className="card-body p-3">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                  <div>
                    <h1 className="h5 fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                      <Receipt className="text-primary" size={20} />
                      Order Summary Report
                    </h1>

                    <div className="text-secondary small">
                      <div className="d-flex align-items-center gap-2">
                        <Store size={14} />
                        <span className="fw-medium">Restaurant:</span>{" "}
                        {selectedRestaurants?.map(item => item?.label)?.join(", ")}
                      </div>
                    </div>
                  </div>
                    {permissions && permissions["View Order Summary Report"] && (
                                                <StoreSelector
                                                  options={Array.isArray(storesList) ? storesList.map(store => ({
                                                    value: store.value,
                                                    label: store.label,
                                                  })) : []}
                                                  value={selectedStoreID}
                                                  onChange={(value) => {
                                                    setSelectedStoreID(value);
                                                    localStorage.setItem("selectedStoreId", value);
                                                  }}
                                                />
                                              )}
                  {
                    permissions && permissions['Export Order Summary Report'] &&

                    <div className="mt-2 mt-md-0">
                      <button
                        className="btn btn-primary btn-sm d-flex align-items-center gap-2 shadow-sm w-100 w-md-auto justify-content-center"
                        onClick={getSalesReportExport}
                        disabled={loadingExport}
                      >
                        <Download size={14} />
                        {loadingExport ? <Spinner size="sm" /> : "Download Excel"}
                      </button>
                    </div>
                  }
                </div>
              </div>


              {/* Filters Bar */}
              <div className="card shadow-sm border-0 mb-3">
                <div className="card-body p-3">
                  <div className="row g-3 align-items-end">
                    {/* From Date */}
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-semibold small">
                        From Date
                      </label>
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="form-control"
                      />
                    </div>

                    {/* To Date */}
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-semibold small">
                        To Date
                      </label>
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="form-control"
                      />
                    </div>

                    {/* Restaurant Multi Select */}
                    <div className="col-12 col-md-4">
                      <label className="form-label fw-semibold small">
                        Choose Restaurant
                      </label>
                      <Select
                        isMulti
                        options={restaurantOptions}
                        value={selectedRestaurants}
                        onChange={setSelectedRestaurants}
                        placeholder="Select restaurants..."
                        //   styles={selectStyles}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{

                          container: (base) => ({
                            ...base,
                            width: "100%",
                            zIndex: '2'
                          }),

                          control: (base) => ({
                            ...base,
                            minHeight: "38px",
                            alignItems: "flex-start", // lets height grow

                          }),

                          valueContainer: (base) => ({
                            ...base,
                            display: "flex",
                            flexWrap: "wrap",     // THIS enables wrapping
                            overflow: "visible", // allow height expansion
                            paddingTop: "4px",
                            paddingBottom: "4px",

                          }),

                          multiValue: (base) => ({
                            ...base,
                            width: "auto",       // allow chip to size naturally
                            maxWidth: "100%",

                          }),

                          multiValueLabel: (base) => ({
                            ...base,
                            whiteSpace: "normal",
                            overflow: "visible",
                            textOverflow: "clip",

                          }),

                          input: (base) => ({
                            ...base,
                            margin: 0, // keeps cursor aligned when wrapped

                          }),
                        }}
                      />
                    </div>

                    {/* Export Button */}
                    <div className="col-12 col-md-2 d-grid">
                      <button
                        className="btn btn-primary fw-semibold"
                        disabled={
                          !fromDate ||
                          !toDate ||
                          selectedRestaurants.length === 0 || loadingReport
                        }
                        onClick={handleExport}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Report Table */}
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">

                {/* Table Header */}
                <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                  <h6 className="mb-0 fw-semibold">
                    Order Summary Report Results
                  </h6>

                  {loadingReport && (
                    <div className="d-flex align-items-center gap-2 text-muted small">
                      <Spinner size="sm" />
                      Loading...
                    </div>
                  )}
                </div>

                {/* Table */}
                <div
                  className="table-responsive"
                  style={{ maxHeight: "65vh", overflowY: "auto" }}
                >
                  <table className="table table-sm table-hover align-middle mb-0 text-center" style={{ fontSize: "12px", textAlign: 'center' }}>
                    <thead className="table-light sticky-top text-center" style={{ zIndex: '1' }}>
                      <tr>
                        <th>Restaurant</th>
                        <th>Date / Time</th>
                        <th>Invoice No</th>
                        <th className="text-center">KOT</th>
                        <th>Payment</th>
                        <th>Order Type</th>
                        <th className="text-center">Persons</th>

                        <th>Status</th>
                        <th>Assigned To</th>
                        <th>Group</th>
                        <th>Cancel Reason</th>

                        <th>Customer</th>
                        <th className="text-center">Phone</th>

                        <th className="text-end">Sub Total</th>
                        <th className="text-end">Tax</th>
                        <th className="text-end">Discount</th>

                        <th className="text-end">Delivery</th>
                        <th className="text-end">Container</th>
                        <th className="text-end">Service</th>
                        <th className="text-end">Additional</th>
                        <th className="text-end">Waived</th>
                        <th className="text-end">Round Off</th>

                        <th className="text-end">Grand Total</th>
                      </tr>
                    </thead>

                    <tbody className="text-center">
                      {/* Loading State */}
                      {loadingReport && (
                        <tr>
                          <td colSpan="23" className="text-center py-4">
                            <Spinner animation="border" size="sm" />
                          </td>
                        </tr>
                      )}

                      {/* Empty State */}
                      {!loadingReport && reportData.length === 0 && (
                        <tr>
                          <td colSpan="23" className="text-center py-4 text-muted">
                            No data found. Please select filters and click Export.
                          </td>
                        </tr>
                      )}

                      {/* Data Rows */}
                      {!loadingReport &&
                        reportData.map((row, idx) => (
                          <tr key={idx} className="text-center">
                            <td className="fw-medium">{row.restaurant_name}</td>

                            <td>{new Date(row.date_time).toLocaleString()}</td>

                            <td className="fw-semibold">{row.invoice_no}</td>

                            <td className="text-center">{row.kot_no}</td>

                            <td>{row.payment_type}</td>

                            <td>{row.order_type}</td>

                            <td className="text-center">{row.persons || "-"}</td>

                            <td>
                              <span
                                style={{ position: "static", borderRadius: "5px" }}
                                className={`badge ${row.status?.toLowerCase().includes("cancel")
                                  ? "bg-danger"
                                  : "bg-success"
                                  }`}
                              >
                                {row.status}
                              </span>
                            </td>

                            <td>{row.assigned_to || "-"}</td>

                            <td>{row.group_name || "-"}</td>

                            <td>{row.order_cancel_reason || "-"}</td>

                            <td>
                              <div className="fw-medium">{row.customer_name}</div>
                              <div className="text-muted small">{row.customer_address}</div>
                            </td>

                            <td className="text-center">{row.customer_phone}</td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.my_amount).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.total_tax).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.discount).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.delivery_charge).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.container_charge).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.service_charge).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.additional_charge).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.waived_off).toLocaleString()}
                            </td>

                            <td className="text-start" style={{ fontFamily: "sans-serif" }}>
                              ₹{Number(row.round_off).toLocaleString()}
                            </td>

                            <td
                              className="text-start fw-semibold text-success"
                              style={{ fontFamily: "sans-serif" }}
                            >
                              ₹{Number(row.total).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderSummaryReport